module.exports = __webpack_public_path__ + "img/DBS.d1d4bddf.png";